var chunkMapping = {
	"2754": [
		15413
	]
};
var idToExternalAndNameMapping = {
	"15413": [
		"default",
		"./index",
		52032
	]
};
var idToRemoteMap = {
	"15413": [
		{
			"externalType": "script",
			"name": "fullbuy",
			"externalModuleId": 52032
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}